// DashboardMetrics.js
import React from "react";

const DashboardMetrics = ({ title, count, onClick }) => (
  <div
    onClick={onClick} // use the onClick prop
    className="bg-secondary p-6 rounded-lg shadow-lg relative flex flex-col items-start cursor-pointer"
  >
    <div>
      <div className="text-light-gray font-medium text-lg">
        {title.split(" ")[0]}
      </div>
      <div className="text-white font-semibold text-xl">
        {title.split(" ")[1]}     {title.split(" ")[2]}
      </div>
    </div>
    <div className="text-yellow font-bold text-4xl">{count}</div>
  </div>
);

export default DashboardMetrics;
